/* istanbul ignore file */
import React from 'react';
import { InputList, InputListProps } from 'framework/form';

const OfferCompensationDetailsListInput = ({ inputTemplate, ...props }: InputListProps) => {
  return <InputList {...props} inputTemplate={inputTemplate} defaultValue={{}} />;
};

export default OfferCompensationDetailsListInput;
